const columns = [
    {
        name: "full_name",
        label: "",
        field: row => `${row.lastName} ${row.firstName}`,
        sortable: true,
        align: "left"
    },
    {
        name: "username",
        label: "",
        field: "username",
        sortable: true,
        align: "left"

    },
    {
        name: "email",
        label: "",
        field: "email",
        sortable: true,
        align: "left"

    },
    {
        name: "icons",
        label: "",
        field: "icons",
        align: "right",
        sortable: false
    }
];

export default columns;
